// extracted by mini-css-extract-plugin
export var box = "customerOverview-module--box--e3bcf";
export var customer = "customerOverview-module--customer--2eb65";
export var customers = "customerOverview-module--customers--a021e";
export var employeesLink = "customerOverview-module--employeesLink--34738";
export var flexbox = "customerOverview-module--flexbox--fd5e1";
export var gatsbyRespImageBackgroundImage = "customerOverview-module--gatsby-resp-image-background-image--1dd31";
export var gatsbyRespImageLink = "customerOverview-module--gatsby-resp-image-link--d858f";
export var image = "customerOverview-module--image--1a4f3";
export var input = "customerOverview-module--input--028b3";
export var load8 = "customerOverview-module--load8--97815";
export var loader = "customerOverview-module--loader--c9375";
export var marqueeContainer = "customerOverview-module--marqueeContainer--83dd4";
export var overwriteWidth = "customerOverview-module--overwriteWidth--76dab";
export var viewwidth = "customerOverview-module--viewwidth--254f4";
export var wrapper = "customerOverview-module--wrapper--33528";